<template>
  <div class="footer" id="footer">
    <div class="footer-wrap clearfix">
      <div class="company-info">
        <div class="logo">
          <img src="/static/img/common/travel-x-f.png" alt="" />
        </div>
        <div style="display: flex">
          <p class="item portusFont">
            {{ $t("footer.portus") }}
          </p>
          <!-- <div class="onlyfz20">
            {{ $t("footer.shanghai") }}
          </div> -->
        </div>

        <div class="flex item fz16">
          {{ $t("footer.address") }}
        </div>
        <!-- <div class="flex item fz16">{{ $t("footer.phone") }}4006999157</div> -->
        <div class="flex item onlyfz16">
          {{ $t("footer.mail") }}support@travel-x.cn
        </div>
      </div>
      <div class="contact-us">
        <div class="contactUsFont">
          {{ $t("footer.follow") }}
        </div>
        <div class="contact_way">
          <div class="contact_way_scan mb28">
            <div class="facebook_position" v-if="isShow === 'facebook'">
              <img
                src="../../../public/static/img/footer/facebook.png"
                alt=""
              />
            </div>

            <div class="wechat_position" v-if="isShow === 'wechat'">
              <img src="../../../public/static/img/footer/travel.png" alt="" />
            </div>

            <div class="weibo_position" v-if="isShow === 'weibo'">
              <img src="../../../public/static/img/footer/weib.png" alt="" />
            </div>

            <div class="xhs_position" v-if="isShow === 'xiaohongshu'">
              <img src="../../../public/static/img/footer/xiao.png" alt="" />
            </div>

            <div
              class="circle_widthHeight"
              @mouseenter="showScan('facebook')"
              @mouseleave="hiddenScan()"
            >
              <img
                src="../../../public/static/img/footer/facebook-icon.png"
                alt=""
              />
            </div>
            <div
              class="circle_widthHeight"
              @mouseenter="showScan('wechat')"
              @mouseleave="hiddenScan()"
            >
              <img src="../../../public/static/img/footer/wechat.png" alt="" />
            </div>
            <div
              class="circle_widthHeight"
              @mouseenter="showScan('weibo')"
              @mouseleave="hiddenScan()"
            >
              <img src="../../../public/static/img/footer/weibo.png" alt="" />
            </div>
            <div
              class="circle_widthHeight"
              @mouseenter="showScan('xiaohongshu')"
              @mouseleave="hiddenScan()"
            >
              <img
                src="../../../public/static/img/footer/xiaohongshu.png"
                alt=""
              />
            </div>
          </div>

          <div class="contact_way_scan" style="justify-content: end">
            <div class="z_index wecom_position" v-if="isShow === 'weCom'">
              <img src="../../../public/static/img/footer/scan.png" alt="" />
            </div>

            <div class="z_index in_position" v-if="isShow === 'in'">
              <img src="../../../public/static/img/footer/ling.png" alt="" />
            </div>

            <div class="z_index camera_position" v-if="isShow === 'camera'">
              <img src="../../../public/static/img/footer/ins.png" alt="" />
            </div>

            <div
              class="circle_widthHeight"
              @mouseenter="showScan('weCom')"
              @mouseleave="hiddenScan()"
            >
              <img src="../../../public/static/img/footer/wecom.png" alt="" />
            </div>
            <div
              class="circle_widthHeight"
              @mouseenter="showScan('in')"
              @mouseleave="hiddenScan()"
            >
              <img src="../../../public/static/img/footer/in.png" alt="" />
            </div>
            <div
              class="circle_widthHeight"
              @mouseenter="showScan('camera')"
              @mouseleave="hiddenScan()"
            >
              <img src="../../../public/static/img/footer/camera.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myFooter",
  props: {
    msg: String
  },
  data () {
    return {
      isShow: ''
    }
  },
  methods: {
    showScan (way) {
      this.isShow = way
    },
    hiddenScan () {
      this.isShow = ''
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
